import styles from './GrandPrixAnouncementSection.module.css';
import { TagsGroup } from '@features/landing/shared/ui/components/TagsGroup';
import { AnouncementSection } from '@features/landing/shared/ui/sections/AnouncementSection';

export function GrandPrixAnouncementSection() {
  return (
    <AnouncementSection
      className={styles.root}
      title={
        <>
          Детские онлайн-турниры с&nbsp;обсчетом рейтинга&nbsp;ФШР<sup>*</sup>
        </>
      }
      tags={
        <>
          <TagsGroup>
            <>Блиц</>
            <>Рапид</>
          </TagsGroup>
          <TagsGroup color="active-faded">
            <>Юноши</>
            <>Девушки</>
          </TagsGroup>
          <div className={styles.tagsForWide}>
            <TagsGroup color="gray">
              <>до 11 лет</>
              <>до 15 лет</>
              <>до 19 лет</>
            </TagsGroup>
          </div>
          <div className={styles.tagsForNarrow}>
            <TagsGroup color="gray">
              <>до 11 лет</>
              <>до 15 лет</>
            </TagsGroup>
            <TagsGroup color="gray">
              <>до 19 лет</>
            </TagsGroup>
          </div>
        </>
      }
      disclaimer={
        <>
          * Допуск при условии соблюдения требований к&nbsp;участникам{' '}
          <span>(см.&nbsp;правила вида спорта шахматы)</span>
        </>
      }
    />
  );
}
